const initialState = {
  recycleBinViewDeleted: null,
  previousHistoricalSearch: null
}

const SET_RECYCLE_BIN_VIEW_DELETED = 'SET_RECYCLE_BIN_VIEW_DELETED'
const CLEAR_RECYCLE_BIN_VIEW_DELETED = 'CLEAR_RECYCLE_BIN_VIEW_DELETED'
const SET_PREVIOUS_HISTORICAL_SEARCH = 'SET_PREVIOUS_HISTORICAL_SEARCH'
const CLEAR_PREVIOUS_HISTORICAL_SEARCH = 'CLEAR_PREVIOUS_HISTORICAL_SEARCH'

export const setRecycleBinViewDeleted = type => ({ payload: type, type: SET_RECYCLE_BIN_VIEW_DELETED })
export const clearRecycleBinViewDeleted = () => ({ type: CLEAR_RECYCLE_BIN_VIEW_DELETED })
export const setPreviousHistoricalSearch = attrs => ({ payload: attrs, type: SET_PREVIOUS_HISTORICAL_SEARCH })
export const clearPreviousHistoricalSearch = () => ({ type: CLEAR_PREVIOUS_HISTORICAL_SEARCH })

export const reducer = (state = initialState, action) => {
  switch (action.type) {
    case SET_RECYCLE_BIN_VIEW_DELETED:
      return { ...state, recycleBinViewDeleted: action.payload }
    case CLEAR_RECYCLE_BIN_VIEW_DELETED:
      return { ...state, recycleBinViewDeleted: null }
    case SET_PREVIOUS_HISTORICAL_SEARCH:
      return { ...state, previousHistoricalSearch: action.payload }
    case CLEAR_PREVIOUS_HISTORICAL_SEARCH:
      return { ...state, previousHistoricalSearch: null }
    default:
      return state
  }
}
